import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function Butik() {
  const produkter = [
    {
      titel: "ØrBike T-Shirt",
      pris: "180 DKK",
      beskrivelse: "Klassisk bomulds t-shirt med officielt ØrBike logo på brystet. Fås i sort og hvid.",
      billede: "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/new-project-13.jpg",
      tag: "Populær"
    },
    {
      titel: "ØrBike Drikkedunk (Bottle)",
      pris: "100 DKK",
      beskrivelse: "Ergonomisk drikkedunk til cykelholderen med hurtig tud og flot ØrBike branding.",
      billede: "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/new-project-12.jpg",
      tag: "Uundværlig"
    },
    {
      titel: "ØrBike Mulepose (Bag)",
      pris: "60 DKK",
      beskrivelse: "Praktisk mulepose i kraftig kvalitet til cykelsko, håndklæde og skiftetøj.",
      billede: "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/new-project-11.jpg",
      tag: "Klassiker"
    },
    {
      titel: "Kalas & CRAFT Cykeltøj",
      pris: "Kommende nyhed",
      beskrivelse: "Officielt Kalas cykeltøj og CRAFT jersey med ØrBike dots – samme kvalitet som instruktørerne kører i!",
      billede: "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-9995.jpg",
      tag: "Nyhed 2026"
    }
  ];

  return (
    <div className="bg-[#090a0f] text-slate-100 min-h-screen pb-20">
      <Helmet>
        <title>Butik - Foreningen ØrBike</title>
        <meta
          name="description"
          content="Køb officielt ØrBike merchandise: T-shirts, drikkedunke, muleposer og Kalas cykeltøj."
        />
        <meta property="og:title" content="Butik - Foreningen ØrBike" />
        <meta property="og:description" content="Se de officielle ØrBike produkter og støt et godt formål." />
      </Helmet>

      {/* Hero Header */}
      <section className="relative pt-36 sm:pt-40 pb-16 sm:pb-20 bg-gradient-to-b from-[#181126] to-[#090a0f] border-b border-pink-500/20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-pink-500/20 text-pink-400 border border-pink-500/30 mb-4">
            Officielt Merchandise
          </span>
          <h1 className="text-4xl sm:text-6xl font-black font-display text-white uppercase tracking-tight">
            ØrBike Butik
          </h1>
          <p className="text-pink-300 font-display text-lg sm:text-2xl font-bold uppercase mt-2">
            Vær en del af ØrBike familien
          </p>
        </div>
      </section>

      <section className="py-16 max-w-[1520px] mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
            Hoodie, mulepose, drikkedunk, t-shirt eller måske en Liiteguard singlet i bordeaux med ØrBike logo på maven – det er nogle af de produkter du kan glæde dig til. Produkterne sælges direkte ved eventet og kan forudbestilles.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {produkter.map((prod, i) => (
            <div
              key={i}
              className="bg-[#12141f] border border-slate-800 hover:border-pink-500/40 rounded-2xl overflow-hidden flex flex-col justify-between transition-all group"
            >
              <div className="relative aspect-square bg-slate-900 overflow-hidden">
                <img
                  src={prod.billede}
                  alt={prod.titel}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <span className="absolute top-3 right-3 bg-pink-500 text-white text-[10px] font-bold uppercase px-2.5 py-0.5 rounded-full shadow">
                  {prod.tag}
                </span>
              </div>

              <div className="p-5 flex-1 flex flex-col justify-between">
                <div>
                  <h3 className="font-bold text-white text-lg font-display uppercase">{prod.titel}</h3>
                  <div className="text-pink-400 font-black font-display text-xl my-1">{prod.pris}</div>
                  <p className="text-xs text-slate-400 leading-relaxed">{prod.beskrivelse}</p>
                </div>

                <div className="mt-5 pt-3 border-t border-slate-800">
                  <Link
                    to="/kontakt"
                    className="w-full inline-flex items-center justify-center gap-2 py-2 rounded-xl bg-slate-800 hover:bg-pink-600 text-white font-bold text-xs uppercase tracking-wider transition-colors"
                  >
                    <span>Forespørg / Køb</span>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
